import { ListItemIcon, ListItemText, Menu, MenuItem, MenuProps } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import React from "react";

interface AnswerContextMenuProps extends MenuProps {
  onEdit?: () => void;
  onDelete?: () => void;
}
export const AnswerContextMenu: React.FC<AnswerContextMenuProps> = ({ onEdit, onDelete, ...props }) => {
  return (
    <Menu {...props}>
      {onEdit && (
        <MenuItem onClick={onEdit}>
          <ListItemIcon>
            <EditOutlinedIcon fontSize="md" sx={{ fill: "#0a3142" }} />
          </ListItemIcon>
          <ListItemText>Edit</ListItemText>
        </MenuItem>
      )}
      {onDelete && (
        <MenuItem onClick={onDelete}>
          <ListItemIcon>
            <DeleteOutlineIcon fontSize="md" sx={{ fill: "#0a3142" }} />
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
        </MenuItem>
      )}
    </Menu>
  );
};
